import React, { useEffect, useMemo, useState } from "react";
// import SideNav from "../sidenav/SideNav";
import "./XetNotification.scss";
import {
  NotificationPreferences,
  NotificationSchema,
  NotificationTypeTags,
  TaskStatusColorSchema,
} from "../../../models/NotificationSchema";

import ApiService from "../../../services/apiService";
import URL from "../../../urls/Urls";
import { useNavigate } from "react-router-dom";
import SocketService from "../../../services/socketService";
import { User } from "../../../models/User";
import { useSelector } from "react-redux";
import { userDetails } from "../../../redux/user/userSelector";
import XetNotificationPreference from "../xet-notification-preference/XetNotificationPreference";
import { formatNotificationStampDate } from "../../../utils/date-util";
import { toast } from "react-toastify";
import { toastOptions } from "../../../utils/toast";
import XetImage from "../xet-image/XetImage";
import { UserState } from "../../../redux/user/userReducer";
import { debounce } from "lodash";
import { SAMPLE_NOTIFICATION_DATA } from "./Sample.data";

const XetNotification: React.FC = () => {
  const [selectedNotificationType, setSelectedNotificationType] =
    useState<string>("");
  const [notificationList, setNotificationList] = useState<
    NotificationSchema[]
  >([]);
  const [openMoreOptionIndex, setOpenMoreOptionIndex] = useState(-1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const user: UserState | null | undefined = useSelector(userDetails);

  useEffect(() => {
    const socket = SocketService.getInstance().getSocket();
    const notificationSound = new Audio(
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240121174730-mixkit-correct-answer-tone-2870.wav",
    );

    socket.on("COMMENT_NOTIFICATIONS", (data: never) => {
      toast.info("New notification", toastOptions);
      try {
        notificationSound.play().then((r) => {
          return r;
        });
      } catch (e) {
        console.error("ERROR PLAYING NOTIFICATION SOUND", e);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    fetchNotificationsList(currentPage, selectedNotificationType).then((r) => {
      return r;
    });
    fetchNotificationPreferences().then((r) => {
      return r;
    });
  }, [currentPage, selectedNotificationType]);

  const fetchNotificationsList = async (
    page: number,
    notification_type: string,
  ) => {
    const response = await ApiService().client.get(
      URL.USERS.FETCH_NOTIFICATIONS,
      {
        params: {
          page,
          notification_type,
        },
      },
    );

    setNotificationList(response.data["notifications"]);
    setTotalPages(response.data["total_pages"]);

    if (page > response.data["total_pages"]) {
      setCurrentPage(response.data["total_pages"]);
    }
  };

  const handlePageClick = (page: number) => {
    setCurrentPage(page);
  };

  const fetchNotificationPreferences = async () => {
    const response = await ApiService().client.get(
      URL.USERS.FETCH_NOTIFICATION_PREFERENCES,
    );
    const data = response.data["preferences"];
  };

  const handleNotificationStatus = async (
    status: string,
    notificationId: number,
  ) => {
    try {
      const response = await ApiService().client.put(
        URL.USERS.UPDATE_NOTIFICATION_STATUS(notificationId),
        {
          read: status === "read",
        },
      );

      if (response.status === 200) {
        setNotificationList((old) => {
          return old.map((row) => {
            return {
              ...row,
              read: row.id === notificationId ? status === "read" : row.read,
            };
          });
        });
        setOpenMoreOptionIndex(-1);
      } else {
        console.error("Failed to update notification status");
      }
    } catch (error) {
      console.error("Error updating notification status:", error);
    }
  };

  const notificationClicked = (
    event: React.MouseEvent,
    notification: NotificationSchema,
  ) => {
    event.stopPropagation();
    if (!notification.read) {
      handleNotificationStatus("read", notification.id);
    }
    window.open(notification.redirection, "_blank");
  };

  const debouncedSearch = useMemo(() => {
    return debounce((searchText: string) => {
      fetchNotificationsList(1, searchText);
    }, 500);
  }, []);

  const handleSearchFile = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const searchText = event.target.value;
    debouncedSearch(searchText);
  };

  return (
    <div className="notifications-page flex-row full-width">
      <div className="notifications-wrapper flex-column">
        <div className="upper-bar">
          <p className="xetgo-font-tag bold px-16 py-12">
            <span className="cursor-pointer">Notifications</span>
          </p>
        </div>
        <div className="notification-lower-main-container p-16 flex-column gap-12 flex-1 overflow-scroll ">
          <div className="notification-list-container flex-1 overflow-scroll">
            {/* Notification card */}

            {notificationList.length === 0 && (
              <div className="flex-column align-items-center justify-content-center full-height">
                <img
                  height={230}
                  width={270}
                  src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250327065428-Nothing+here.svg"
                  alt="empty-box-icon"
                />
                <p className="empty-text xetgo-font-subHeading ">
                  No Notifications Yet
                </p>
              </div>
            )}

            {notificationList.map((notification, index) => {
              return (
                <div
                  key={index}
                  className="notification-tile flex-row"
                  style={notification.read ? { background: "white" } : {}}
                  onClick={(event) => {
                    notificationClicked(event, notification);
                  }}
                >
                  {notification.miscellaneous_details &&
                  notification.miscellaneous_details.creator_avatar ? (
                    <div className="user-avatar-container">
                      <img
                        src={notification.miscellaneous_details?.avatar}
                        width={32}
                        height={32}
                        alt="profile"
                      />
                    </div>
                  ) : (
                    <XetImage
                      alt={notification.miscellaneous_details.name || ""}
                      height={32}
                      width={32}
                    />
                  )}

                  <div className="notification-tile-content flex-column">
                    <span className="user-name flex-row gap-8">
                      <span>{notification.miscellaneous_details?.name}</span>
                      <span
                        style={{
                          color:
                            NotificationTypeTags[
                              notification.source_type.toUpperCase()
                            ].color === "#FFFFFF"
                              ? "#965DF8"
                              : NotificationTypeTags[
                                  notification.source_type.toUpperCase()
                                ].color,
                        }}
                        className={`uuid-quote `}
                      >
                        #{notification.title}
                      </span>

                      <span
                        className="notification-type flex-row align-items-center justify-content-center"
                        style={{
                          color:
                            NotificationTypeTags[
                              notification.source_type.toUpperCase()
                            ].color,
                          background:
                            NotificationTypeTags[
                              notification.source_type.toUpperCase()
                            ].background,
                        }}
                      >
                        {
                          NotificationTypeTags[
                            notification.source_type.toUpperCase()
                          ].displayName
                        }
                      </span>
                    </span>

                    <span
                      style={{ color: "#AA5200" }}
                      className="notification-title"
                    >
                      {notification.miscellaneous_details.company_name}
                    </span>

                    {notification.miscellaneous_details.files?.length > 0 && (
                      <div className="all-comment-files flex-row gap-12">
                        {notification.miscellaneous_details.files.map(
                          (file: { id: number; url: string; name: string }) => (
                            <div
                              key={file.url}
                              onClick={() => window.open(file.url, "_blank")}
                              className="file-main-container flex-row gap-4 xetgo-font-tag align-items-center bold"
                            >
                              <img
                                height={16}
                                width={16}
                                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241204053638-file-text.svg"
                                alt="file-icon"
                              />
                              <p>{file.name}</p>
                            </div>
                          ),
                        )}
                      </div>
                    )}

                    <span className="notification-description">
                      {/* {notification.notification_type === "STATUS_UPDATE" && (
                        <div className="status-update-content flex-row">
                          <span
                            className="previous-status"
                            style={{
                              background:
                                TaskStatusColorSchema[
                                  notification.miscellaneous_details[
                                    "old_status"
                                  ]
                                ].background,
                              color:
                                TaskStatusColorSchema[
                                  notification.miscellaneous_details[
                                    "old_status"
                                  ]
                                ].color,
                              textTransform: "capitalize",
                            }}
                          >
                            {notification.miscellaneous_details["old_status"]}
                          </span>

                          <img
                            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240119120158-arrow-right.svg"
                            alt=""
                          />

                          <span
                            className="next-status"
                            style={{
                              background:
                                TaskStatusColorSchema[
                                  notification.miscellaneous_details[
                                    "new_status"
                                  ]
                                ].background,
                              color:
                                TaskStatusColorSchema[
                                  notification.miscellaneous_details[
                                    "new_status"
                                  ]
                                ].color,
                              textTransform: "capitalize",
                            }}
                          >
                            {notification.miscellaneous_details["new_status"]}
                          </span>
                        </div>
                      )}
                      {notification.notification_type === "TASK_ASSIGNED" && (
                        <div className="status-update-content flex-row">
                          <span
                            className="next-status"
                            style={{
                              background:
                                TaskStatusColorSchema[
                                  notification.miscellaneous_details[
                                    "new_status"
                                  ]
                                ].background,
                              color:
                                TaskStatusColorSchema[
                                  notification.miscellaneous_details[
                                    "new_status"
                                  ]
                                ].color,
                              textTransform: "capitalize",
                            }}
                          >
                            {notification.miscellaneous_details["new_status"]}
                          </span>
                        </div>
                      )} */}

                      {notification.notification_type === "COMMENT" && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                              notification.miscellaneous_details.description,
                          }}
                        />
                      )}
                    </span>
                  </div>

                  <div className=" flex-column right-side-date-unread-box  justify-content-space-between">
                    <span>
                      {formatNotificationStampDate(notification.created_at)}
                    </span>
                    {notification.read && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNotificationStatus("unread", notification.id);
                        }}
                        className="unread-box xetgo-font-tag p-6 flex-row align-items-center justify-content-center gap-8"
                      >
                        <p>Mark as unread</p>
                        <img
                          height={12}
                          width={12}
                          src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250325131823-solar_chat-unread-linear.svg"
                          alt="comment-icon"
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {notificationList.length > 0 && (
          <div className="pagination-container flex-row align-items-center ">
            {totalPages > 1 && (
              <>
                <span
                  className={`pagination-previous p-4 flex-row align-items-center justify-content-center xetgo-font-tag-bold cursor-pointer${
                    currentPage === 1 ? " active-page" : ""
                  }`}
                  onClick={() => {
                    if (currentPage > 1) {
                      handlePageClick(currentPage - 1);
                    }
                  }}
                >
                  <img
                    height={20}
                    width={20}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240912174942-chevron-right.svg"
                    alt="previous-icon"
                  />
                </span>
                {Array.from(
                  { length: totalPages },
                  (_, index) => index + 1,
                ).map((page) => (
                  <span
                    key={page}
                    className={`pagination-number  xetgo-font-tag-bold cursor-pointer${
                      currentPage === page ? " active-page" : ""
                    }`}
                    onClick={() => handlePageClick(page)}
                  >
                    {page}
                  </span>
                ))}
                <span
                  className={`pagination-previous pagination-next p-4 flex-row align-items-center justify-content-center xetgo-font-tag-bold cursor-pointer${
                    currentPage === 1 ? " active-page" : ""
                  }`}
                  onClick={() => {
                    if (currentPage < totalPages) {
                      handlePageClick(currentPage + 1);
                    }
                  }}
                >
                  <img
                    className="next-icon"
                    height={20}
                    width={20}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240912174942-chevron-right.svg"
                    alt="previous-icon"
                  />
                </span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default XetNotification;
